/**
 * This is used as a localStorage replacement for the Chrome Extension for when the user doesn't
 * have 3rd party cookies enabled.
 *
 * (Used to be for cross-domain localStorage, but that's no longer needed since Readlang is
 * https-only)
 */
import * as _ from "underscore";

const tempStorageMode = window.READLANG.chromeExtension;

/** Used for Chrome Extension */
let tempStorage = {};

const verbose = false;

export const setItem = (key, value, callback?: () => void) => {
  if (tempStorageMode) {
    if (verbose) {
      console.log("Set item: ", key, value);
    }
    tempStorage[key] = value;
    callback?.();
    return;
  }

  localStorage.setItem(key, value);
  callback?.();
};

export const setItemPromise = (key, value) => {
  return new Promise((resolve: any) => {
    setItem(key, value, resolve);
  });
};

export const getItem = (key, callback) => {
  if (tempStorageMode) {
    callback(tempStorage[key]);
    return;
  }

  callback(localStorage.getItem(key));
};

export const getItemPromise = (key): Promise<string | undefined> => {
  return new Promise((resolve) => {
    getItem(key, resolve);
  });
};

export const removeItem = (key, callback?: () => void) => {
  if (tempStorageMode) {
    if (verbose) {
      console.log("Remove item: ", key);
    }
    delete tempStorage[key];
    callback?.();
    return;
  }

  localStorage.removeItem(key);
  callback?.();
};

export const removeItemPromise = (key) => {
  return new Promise((resolve: any) => {
    removeItem(key, resolve);
  });
};

export const clearWithExceptions = (exceptions, callback) => {
  if (tempStorageMode) {
    if (verbose) {
      if (exceptions.length === 0) {
        console.log("Clear storage");
      } else {
        console.log("Clear storage, except for ", exceptions.join(", "));
      }
    }
    for (const key in tempStorage) {
      if (exceptions.indexOf(key) === -1) {
        delete tempStorage[key];
      }
    }
    callback();
    return;
  }

  const keys = [];

  for (let i = 0; i < localStorage.length; i++) {
    keys[i] = localStorage.key(i);
  }

  _.each(keys, (key) => {
    let keep = false;
    _.each(exceptions, (exception) => {
      if (new RegExp(exception).test(key)) {
        keep = true;
        return false;
      }
    });

    if (!keep) {
      localStorage.removeItem(key);
    }
  });
  if (callback) {
    callback();
  }
};

export const clear = (callback) => {
  clearWithExceptions([], callback);
};

export const clearPromise = () => {
  return new Promise((resolve) => {
    clear(resolve);
  });
};
